import { blankGapRule, deleteGapRule, gapRuleById, GapRuleView, saveGapRule } from '@elva/ui';
import { useMemo } from 'react';
import { Navigate, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useClearPageTopBarActions } from '@/app/layouts/pageTopBar';

/**
 * Add or edit a Gap Filler rule (amendment 26 §5). `/rules/new` starts a blank
 * custom rule; `/rules/<id>` edits an existing one. `?focus=shortest-gap` comes
 * from card 05's *Shorten a rule's minimum* and focuses that field.
 */
export function GapRulePage() {
  useClearPageTopBarActions();
  const navigate = useNavigate();
  const { ruleId } = useParams<{ ruleId: string }>();
  const [params] = useSearchParams();
  const isNew = ruleId === undefined || ruleId === 'new';

  // A blank rule is made once per mount, not on every render.
  const fresh = useMemo(() => blankGapRule(), []);
  const rule = isNew ? fresh : gapRuleById(ruleId);
  if (rule === undefined) return <Navigate to="/settings/ai/gap-filler" replace />;

  return (
    <GapRuleView
      rule={rule}
      isNew={isNew}
      focus={params.get('focus') ?? undefined}
      onSave={(next) => { saveGapRule(next); void navigate('/settings/ai/gap-filler'); }}
      onCancel={() => { void navigate('/settings/ai/gap-filler'); }}
      onDelete={() => { deleteGapRule(rule.id); void navigate('/settings/ai/gap-filler'); }}
    />
  );
}
